import { UserGroup } from './auth';
import { DateTimeISO } from './common';
import { BaseCompany } from './companies';
import { SelectOption } from './inputs';
import { PublicStaff } from './staff';

export enum UserRoles {
  CONSUMER = 'consumer',
  TEAMMATE_ADMIN = 'teammate_admin',
  TEAMMATE_ADVISOR = 'teammate_advisor',
  TEAMMATE_SUPPORTER = 'teammate_supporter',
  STAFF = 'staff',
  NONE = 'none',
}

export type UserInfo = {
  uuid: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  cellPhoneNumber: string;
  businessPhoneNumber: string;
  dob: DateTimeISO;
  avatar: string;
  deactivatedDate: DateTimeISO;
  lastLogin: DateTimeISO;
  bio: string;
  title: string;
  isSandbox: boolean;
};

export type Member = {
  company: BaseCompany;
  user: UserInfo;
  uuid: string;
  signedDateTime?: string;
  isPrimaryOwner?: boolean;
};

export type UserResponse = {
  uuid: string;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  businessPhoneNumber: string;
  dateOfBirth: string;
  avatarUrl: string;
  title: string;
  lastLoginAt: DateTimeISO;
  role: UserRoles;
  bio: string;
  consumerInfo?: {
    uuid: string;
  };
  teammateInfo?: {
    uuid: string;
    advisorUrl: string;
    alias: string;
    company: {
      uuid: string;
      name: string;
      rateSavingInterest: number;
      companyUrl: string;
    };
    members: {
      uuid: string;
      firstName: string;
      lastName: string;
      fullName: string;
    }[];
  };
  staffInfo?: PublicStaff;
};

export const queryKeys = {
  detail: ['userInfo'] as const,
};

export type ProfileFormValues = {
  firstName: string;
  lastName: string;
  email: string;
  company: string;
  role: string;
  title: string;
  phone: string;
  businessPhone: string;
  avatarUrl: string;
  avatarDisplayName: string;
  supportMembers: SelectOption[];
  personalBankLink: string;
  bio: string;
};

export type PublicUser = {
  uuid: string;
  firstName: string;
  lastName: string;
  fullName: string;
  userType: UserGroup;
};
